module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 144.2f7da1de.png";